import * as React from "react";
import { IScenarioState, ILocation } from "./Scenario";
import { ActiveLocationComponent } from "./ActiveLocationComponent";
import { CardType } from "./Card";
import * as LocationMenuItemComponent from "./LocationMenuItemComponent";

export interface ICurrentLocationSelectorProps {
    state: IScenarioState;
    onChanged: () => void;
}
export class CurrentLocationSelectorComponent extends React.Component<ICurrentLocationSelectorProps, any>  {

    activateLocation(id: number) {
        this.props.state.locations.filter(l => l.card.packNumber === id)[0].inactive = false;
        this.props.onChanged();
    }
    render() {
        const activeLocationMenuItems = this.props.state.locations.filter(l => !l.inactive).map((loc, i) => {
            return (<LocationMenuItemComponent.LocationMenuItemComponent key={i} state={this.props.state} location={loc} onChanged={() => { this.props.onChanged(); }} />);
        });

        let locationComponent: JSX.Element;
        const activeLocId = LocationMenuItemComponent.LocationMenuItemComponent.getCurrentSelectedLocationId(this.props.state);
        const inactiveLocations = this.props.state.locations.filter(l => l.inactive);
        if (activeLocId === LocationMenuItemComponent.LocationMenuItemComponent.newLocationId) {
            const inactiveLocationItems = inactiveLocations.map((loc, i) => {
                return (<li key={i}><button onClick={() => this.activateLocation(loc.card.packNumber)}>{loc.card.name}</button></li>);
            });
            locationComponent = <div id="add-new-location"><ul>{inactiveLocationItems}</ul></div>;
        } else {
            locationComponent = <ActiveLocationComponent state={this.props.state} locationId={activeLocId} onChanged={() => this.props.onChanged()} />;
        }
        const addNewLocation: ILocation = {
            card: {
                name: "Add new location",
                unique:false,
                packNumber: LocationMenuItemComponent.LocationMenuItemComponent.newLocationId,
                pack: 1,
                type: CardType.Location,
                faceUp: false
            },
            inactive: false
        }
        return (
            <div id="locations">
                <div id="currentLocationSelector">
                    <ul className="active-selector">
                        {activeLocationMenuItems}
                        {inactiveLocations.length
                            ? <LocationMenuItemComponent.LocationMenuItemComponent state={this.props.state} location={addNewLocation} onChanged={() => { this.props.onChanged(); }} />
                            : null}
                    </ul>
                </div>
                {locationComponent}
            </div>
        );
    }
}
